import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { CoaGroupWizardContainer } from './group-wizard-container';

interface CreateCoaGroupSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateCoaGroupSidebar = ({ isOpen, onClose }: CreateCoaGroupSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="common.create_group" defaultMessage="Create group" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <CoaGroupWizardContainer onClose={onClose} />
  </Sidebar>
);
